import React, { useEffect, useRef, useState } from "react";
import "./UserSubmissionDetails.scss";
import {
  GreyBorderButton,
  RedBackgroundButton,
} from "../../Global/GlobalButton";
import { RedMainHeading } from "../../Global/GlobalText";
import {
  InputLabel,
  InputTextarea,
  InputType,
  SelectBorder,
} from "../../Global/GlobalFormElement";
import { UserTopBanner } from "../../Global/User-Flow/UserTopBanner/UserTopBanner";
import { UserBottomBar } from "../../Global/User-Flow/UserBottomBar/UserBottomBar";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { EXCHNAGE_URL, EXHANGE_URL_IMAGE_UPLOAD } from "../../../Url/Url";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import imageCompression from "browser-image-compression";
import { useLoading } from "../../LoadingContext";

const countries = [
  "United States",
  "Canada",
  "United Kingdom",
  "Australia",
  "India",
  "Germany",
  "France",
  "Italy",
  "Spain",
  "Mexico",
  "Japan",
  "South Korea",
  "Brazil",
  "China",
  "South Africa",
  "Russia",
  "Netherlands",
  "Sweden",
  "Switzerland",
  "Belgium",
];

export const AdminEdit =({
  isEdit,
  initialData,
  submissionId,
  entryFormId,
  eventId,
  submissionUserId,
}) => {
  const [formData, setFormData] = useState({});
  const [formSchema, setFormSchema] = useState([]);
  const [errors, setErrors] = useState({});
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("newest");
  const [selectedAwardId, setSelectedAwardId] = useState();
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const userRole = useSelector((state) => state?.users?.user?.role);
const location = useLocation();

// fallback only
const {
  eventId: locationEventId,
  entryFormId: locationEntryFormId,
} = location.state || {};

// ✅ FINAL VALUES
const finalEventId = eventId || locationEventId;
const finalEntryFormId = entryFormId || locationEntryFormId;
  const navigate = useNavigate();
  const { setLoading } = useLoading();
const {
  event_logo,
  event_banner,
  closing_date,
  closing_time,
  event_name,
} = location.state || {};
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const openCancelModal = () => {
    setIsCancelModalOpen(true);
  };

  const closeCancelModal = () => {
    setIsCancelModalOpen(false);
  };

  const handleCancel = () => {
    setFormData({});
    setIsCancelModalOpen(false);
    toast.info("Form submission canceled.");
    if (userRole === "admin") {
      navigate("/dashboard");
    } else {
      navigate("/user-dashboard");
    }
  };

  const handleEntryForm = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${EXCHNAGE_URL}/entryForm?eventId=${finalEventId}&entryFormId=${finalEntryFormId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response.status === 200) {
        toast.success("Entry form fetched successfully");
        const fetchedFields = response.data.data.form_schema;
        const jsonArray = JSON.parse(fetchedFields);
        setFormSchema(jsonArray);
      } else {
        toast.error("Failed to fetch the Entry form.");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const hasFetchedOnce = useRef(false);

  useEffect(() => {
    if (!hasFetchedOnce.current) {
      handleEntryForm();
      hasFetchedOnce.current = true;
    }
  }, []);




useEffect(() => {
  if (formSchema.length > 0) {
    const initial = formSchema.reduce((acc, field) => {
      acc[field.dataName] = {
        value: field.defaultValue || "",
        isConditionMet: field.isConditionMet,
        isRequired: field.isRequired || false,
        label: field.label,
        isVisible: field.visible || true,
        dataName: field.dataName || "",
        selectedLabelPosition: field.selectedLabelPosition || "",
        visible: field.isVisibleIf ? false : field.visible || true,
        isVisibleIf: field.isVisibleIf,
        uploadFileSize: field.uploadFileSize || "",
        uploadFileType: field.uploadFileType
          ? [...field.uploadFileType]
          : [],
        type: field.type,
      };
      return acc;
    }, {});

    // 🔥 EDIT DATA APPLY
    if (isEdit && initialData) {
      Object.keys(initial).forEach((key) => {
        if (initialData[key] !== undefined) {
          initial[key].value = initialData[key];
        }
      });
    }

    setFormData(initial);
  }
}, [formSchema, isEdit, initialData]);

  const getCategories = async () => {
    setIsLoading(true);
    try {
      let apiUrl = `${EXCHNAGE_URL}/userformcategorylist?eventId=${eventId}&sortOrder=${sortOrder}`;
      if (searchTerm) {
        apiUrl += `&search=${searchTerm}`;
      }
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (response.status === 200) {
        setCategories(response.data.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCategories();
  }, [eventId, searchTerm, sortOrder]);

  const handleRadioAndDropDown = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value,
      },
    }));
  };

  const handleCheckboxChange = (name, option) => {
    setFormData((prev) => {
      const currentValue = prev[name]?.value;
      return {
        ...prev,
        [name]: {
          ...prev[name],
          value: currentValue === option ? "" : option,
        },
      };
    });
  };

  const handlePosition = () => {
    formSchema.forEach((field) => {
      const { selectedLabelPosition, dataName } = field;
      const fieldToCheck = formData[dataName];
      if (
        fieldToCheck &&
        fieldToCheck.selectedLabelPosition !== selectedLabelPosition
      ) {
        setFormData({
          ...formData,
          [dataName]: {
            ...fieldToCheck,
            selectedLabelPosition: selectedLabelPosition,
          },
        });
      }
    });
  };

  const handleFileChange = async (event, dataName) => {
    const file = event.target.files[0];
    if (!file) return;

    const field = formData[dataName];
    if (!field) return;

    const maxSizeMB = parseFloat(field.uploadFileSize) || 10;
    const allowedTypes = field.uploadFileType || [];

    const fileSizeMB = file.size / (1024 * 1024);
    if (fileSizeMB > maxSizeMB) {
      toast.error(`File size should not exceed ${maxSizeMB} MB`);
      return;
    }

    const fileExtension = `.${file.name.split(".").pop()}`.toLowerCase();
    if (allowedTypes.length > 0 && !allowedTypes.includes(fileExtension)) {
      toast.error(
        `Invalid file type. Allowed types: ${allowedTypes.join(", ")}`,
      );
      return;
    }

    let processedFile = file;
    if (file.type.startsWith("image/")) {
      try {
        const options = {
          maxSizeMB: maxSizeMB,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
        };
        processedFile = await imageCompression(file, options);
      } catch (error) {
        console.error("Error compressing image:", error);
        toast.error("Failed to compress image. Please try again.");
        return;
      }
    }

    const processedFileSizeMB = processedFile.size / (1024 * 1024);
    if (processedFileSizeMB > maxSizeMB) {
      toast.error(`File size after compression exceeds ${maxSizeMB} MB.`);
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      [dataName]: {
        ...prevData[dataName],
        file: processedFile, // Store the file object
        valid: true,
      },
    }));
    toast.success("File selected successfully.");
  };

  const uploadFilesToBackend = async () => {
    const fileFields = Object.entries(formData).filter(
      ([_, field]) => field.type === "file" && field.file,
    );

    if (!fileFields.length) return [];

    const formDataToSend = new FormData();
    fileFields.forEach(([dataName, field]) => {
      formDataToSend.append(dataName, field.file, field.file.name);
    });
   formDataToSend.append("eventid", eventId);
formDataToSend.append("formid", entryFormId);
formDataToSend.append("userId", submissionUserId); // 🔥 MAIN FIX

    try {
      const response = await axios.post(
        `${EXHANGE_URL_IMAGE_UPLOAD}/media`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      const uploadedFiles = response.data.files.map((file) => ({
        dataName: file.field,
        mediaId: file.id,
        s3Key: `uploads/${file.field}`, // Match backend s3Key format
      }));

      // Update formData with media IDs
      uploadedFiles.forEach(({ dataName, mediaId, s3Key }) => {
        setFormData((prev) => ({
          ...prev,
          [dataName]: {
            ...prev[dataName],
            value: mediaId, // Store media ID as value
            file: null, // Clear file after upload
          },
        }));
      });

      return uploadedFiles;
    } catch (error) {
      console.error("Error uploading files to backend:", error);
      toast.error("Failed to upload files. Please try again.");
      throw error;
    }
  };

  const checkRequiredCondition = () => {
    let updated = false;
    formSchema.forEach((field) => {
      const {
        requiredFieldValue = [],
        requiredConditionValue = [],
        requiredCriteriaPattern = "",
        dataName,
        requiredCondition = "Equals",
      } = field;

      const fieldValues = Array.isArray(requiredFieldValue)
        ? requiredFieldValue
        : [requiredFieldValue];
      const conditionValues = Array.isArray(requiredConditionValue)
        ? requiredConditionValue
        : [requiredConditionValue];

      if (
        !fieldValues.length ||
        !conditionValues.length ||
        !dataName ||
        !requiredCriteriaPattern
      )
        return;

      const relatedFieldKey = dataName;
      const relatedField = formData[relatedFieldKey];

      if (!relatedField) return;

      const patternTokens = requiredCriteriaPattern
        .split(/\s+/)
        .filter((part) => part.trim() !== "");
      const conditionIndexes = patternTokens
        .map((token, idx) => (isNaN(token) ? null : parseInt(token) - 1))
        .filter((idx) => idx !== null);

      if (conditionIndexes.length === 0) return;

      const evaluateCondition = (index) => {
        if (index < 0 || index >= fieldValues.length) return false;
        const fieldToCheck = Object.values(formData).find(
          (field) => field.label === fieldValues[index],
        );
        if (!fieldToCheck) return false;

        const valueToCheck = fieldToCheck.value;
        const expectedValue = conditionValues[index] || conditionValues[0];

        switch (requiredCondition) {
          case "Equals":
            return valueToCheck === expectedValue;
          case "contains":
            return valueToCheck.includes(expectedValue);
          case "startsWith":
            return valueToCheck.startsWith(expectedValue);
          case "endsWith":
            return valueToCheck.endsWith(expectedValue);
          case "not-contains":
            return !valueToCheck.includes(expectedValue);
          case "not-startsWith":
            return !valueToCheck.startsWith(expectedValue);
          case "not-endsWith":
            return !valueToCheck.endsWith(expectedValue);
          default:
            return valueToCheck === expectedValue;
        }
      };

      let conditionMet = false;
      if (patternTokens.includes("AND")) {
        conditionMet = conditionIndexes.every((index) =>
          evaluateCondition(index),
        );
      } else if (patternTokens.includes("OR")) {
        conditionMet = conditionIndexes.some((index) =>
          evaluateCondition(index),
        );
      } else {
        conditionMet = evaluateCondition(conditionIndexes[0]);
      }

      if (relatedField.isRequired !== conditionMet) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [relatedFieldKey]: {
            ...relatedField,
            isRequired: conditionMet,
          },
        }));
        updated = true;
      }
    });

    if (!updated) {
      return;
    }
  };

  const checkVisibilityCondition = () => {
    formSchema.forEach((fieldPayloadItem) => {
      const {
        visibleFieldValue = [],
        visibleConditionValue = [],
        visibleCriteriaPattern = "",
        dataName = "",
        visibleCondition = "Equals",
        isVisibleIf = true,
      } = fieldPayloadItem;

      const fieldValues = Array.isArray(visibleFieldValue)
        ? visibleFieldValue
        : [visibleFieldValue];
      const conditionValues = Array.isArray(visibleConditionValue)
        ? visibleConditionValue
        : [visibleConditionValue];

      if (
        !fieldValues.length ||
        !conditionValues.length ||
        !dataName ||
        !visibleCriteriaPattern
      )
        return;

      const relatedFieldKey = dataName;
      const relatedField = formData[relatedFieldKey];

      if (!relatedField) return;

      const patternTokens = visibleCriteriaPattern
        .split(/\s+/)
        .filter((part) => part.trim() !== "");
      const conditionIndexes = patternTokens
        .map((token, idx) => (isNaN(token) ? null : parseInt(token) - 1))
        .filter((idx) => idx !== null);

      if (conditionIndexes.length === 0) return;

      const evaluateCondition = (index) => {
        if (index < 0 || index >= fieldValues.length) return false;
        const fieldToCheck = Object.values(formData).find(
          (field) => field.dataName === fieldValues[index],
        );
        if (!fieldToCheck) return false;

        const valueToCheck = fieldToCheck.value;
        const expectedValue = conditionValues[index] || conditionValues[0];

        switch (visibleCondition) {
          case "Equals":
            return valueToCheck === expectedValue;
          case "contains":
            return valueToCheck.includes(expectedValue);
          case "startsWith":
            return valueToCheck.startsWith(expectedValue);
          case "endsWith":
            return valueToCheck.endsWith(expectedValue);
          case "not-contains":
            return !valueToCheck.includes(expectedValue);
          case "not-startsWith":
            return !valueToCheck.startsWith(expectedValue);
          case "not-endsWith":
            return !valueToCheck.endsWith(expectedValue);
          default:
            return valueToCheck === expectedValue;
        }
      };

      let conditionMet = false;
      if (patternTokens.includes("AND")) {
        conditionMet = conditionIndexes.every((index) =>
          evaluateCondition(index),
        );
      } else if (patternTokens.includes("OR")) {
        conditionMet = conditionIndexes.some((index) =>
          evaluateCondition(index),
        );
      } else {
        conditionMet = evaluateCondition(conditionIndexes[0]);
      }

      const newVisibility = isVisibleIf ? conditionMet : relatedField.visible;

      if (relatedField.visible !== newVisibility) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [relatedFieldKey]: {
            ...relatedField,
            visible: newVisibility,
          },
        }));
      }
    });
  };

  useEffect(() => {
    checkRequiredCondition();
    checkVisibilityCondition();
    handlePosition();
  }, [formSchema, formData]);

  const handleRadioChange = (fieldName, value) => {
    setFormData({
      ...formData,
      [fieldName]: value,
    });
  };

  const handleInputChange = (dataName, value) => {
    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [dataName]: {
          ...prevData[dataName],
          value: value,
        },
      };
      return updatedData;
    });
  };

  const handleCategoryChange = (e, dataName, value) => {
    const selectedCategoryName = e.target.value;
    const selectedAwardId =
      e.target.options[e.target.selectedIndex].getAttribute("data-award-id");

    setSelectedCategoryName(selectedCategoryName);
    setSelectedAwardId(selectedAwardId);
    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [dataName]: {
          ...prevData[dataName],
          value,
        },
      };
      return updatedData;
    });
  };

  const renderField = (field) => {
    const relatedField = formData[field.dataName];
    if (!relatedField?.isConditionMet) return null;

    const requiredConditionMet = checkRequiredCondition(field);
    const fieldClass = relatedField?.isVisible ? "show" : "hide";

    handlePosition(relatedField);
    const labelPositionLeft = relatedField?.selectedLabelPosition === "left";

    const fieldPayloadItem = formSchema?.find(
      (item) => item.dataName === field.dataName,
    );
    const fieldWidth = fieldPayloadItem?.selectedFieldSize || "100%";

    const fieldStyle = {
      display: "flex",
      flexDirection: labelPositionLeft ? "row" : "column",
      alignItems: labelPositionLeft ? "center" : "flex-start",
    };

    const labelStyle = {
      marginRight: labelPositionLeft ? "10px" : "0",
      width: labelPositionLeft ? "55%" : "auto",
      textAlign: labelPositionLeft ? "left" : "center",
    };

    const inputStyle = {
      width: fieldWidth,
      marginLeft: labelPositionLeft ? "0" : "0",
    };

    const labelText = field.label || relatedField?.label;
    const containsHTML = /<[a-z][\s\S]*>/i.test(labelText);

    let hasRendered = false;
    const hoverHint =
      formSchema.find((item) => item.dataName === field.dataName)?.hoverHint ||
      "";

    if (!relatedField.visible) return null;
    if (!field.isVisibleIf && !field.visible) return null;

    return (
      <div className={relatedField.visible ? "show" : "hide"}>
        <div key={field.dataName} className="form-field" style={fieldStyle}>
          <label style={labelStyle}>
{/* ✅ HTML support for label */}
  {/<[a-z][\s\S]*>/i.test(labelText) ? (
    <span 
      className="form-label-html"
      dangerouslySetInnerHTML={{ __html: labelText }} 
    />
  ) : (
    labelText
  )}            {(relatedField?.isRequired ||
              (relatedField?.isRequired === false &&
                formSchema?.some(
                  (item) =>
                    item.dataName === field.dataName &&
                    (!item.requiredConditionValue ||
                      item.requiredConditionValue.every(
                        (val) => val.trim() === "",
                      )) &&
                    item.required,
                ))) && <span style={{ color: "red" }}>*</span>}
            {hoverHint && (
              <span className="hover-hint-icon" title={hoverHint}>
                ?
              </span>
            )}
          </label>

          {(() => {
            switch (field.type) {
              case "dropdown":
                if (!hasRendered) {
                  hasRendered = true;
                  if (field.label === "Category") {
                    return (
                      <SelectBorder
                        name="category"
                        value={selectedCategoryName}
                        onChange={(e) =>
                          handleCategoryChange(
                            e,
                            field.dataName,
                            e.target.value,
                          )
                        }
                      >
                        <option value="">Select a Category</option>
                        {categories.map((category) => (
                          <option
                            key={category.awardId}
                            data-award-id={category.awardId}
                            value={category.category_name}
                          >
                            {category.category_name}
                          </option>
                        ))}
                      </SelectBorder>
                    );
                  } else {
                    return (
                      <SelectBorder
                        value={relatedField?.value || ""}
                        onChange={(e) =>
                          handleRadioAndDropDown(field.dataName, e.target.value)
                        }
                        required={
                          requiredConditionMet || relatedField?.isRequired
                        }
                        style={inputStyle}
                      >
                        <option value="">Select an Option</option>
                        {field.options?.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </SelectBorder>
                    );
                  }
                }
                break;
              case "text":
                if (!hasRendered) {
                  hasRendered = true;
                  if (field.label === "Category") {
                    return (
                      <SelectBorder
                        name="category"
                        value={selectedCategoryName}
                        onChange={handleCategoryChange}
                      >
                        <option value="">Select a Category</option>
                        {categories.map((category) => (
                          <option
                            key={category.awardId}
                            data-award-id={category.awardId}
                            value={category.category_name}
                          >
                            {category.category_name}
                          </option>
                        ))}
                      </SelectBorder>
                    );
                  } else {
                    return (
                      <InputType
                        type="text"
                        placeholder={field.placeholder || ""}
                        value={relatedField?.value || ""}
                        onChange={(e) =>
                          handleInputChange(field.dataName, e.target.value)
                        }
                        required={
                          requiredConditionMet || relatedField?.isRequired
                        }
                        style={inputStyle}
                      />
                    );
                  }
                }
                break;
              case "textarea":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <InputTextarea
                      placeholder={
                        field.placeholder || field.defaultValue || ""
                      }
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={{ ...inputStyle, height: "100px" }}
                    />
                  );
                }
                break;
              case "radio":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <>
                      {field.options &&
                        field.options.map((option, index) => (
                          <div key={index} className="sub_form_preview_radio">
                            <InputType
                              type="radio"
                              name={field.dataName}
                              value={option}
                              checked={relatedField?.value === option}
                              onChange={() =>
                                handleRadioAndDropDown(field.dataName, option)
                              }
                              required={
                                requiredConditionMet || relatedField?.isRequired
                              }
                              style={inputStyle}
                            />
                            <label>{option}</label>
                          </div>
                        ))}
                    </>
                  );
                }
                break;
              case "checkbox":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <>
                      {field.options &&
                        field.options.map((option, index) => (
                          <div key={index} className="sub_form_preview_radio">
                            <InputType
                              type="checkbox"
                              name={field.dataName}
                              value={option}
                              checked={relatedField?.value === option}
                              onChange={() =>
                                handleCheckboxChange(field.dataName, option)
                              }
                              required={
                                requiredConditionMet || relatedField?.isRequired
                              }
                              style={inputStyle}
                            />
                            <label>{option}</label>
                          </div>
                        ))}
                    </>
                  );
                }
                break;
              case "email":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <InputType
                      type="email"
                      placeholder={field.placeholder || ""}
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={inputStyle}
                    />
                  );
                }
                break;
              case "tel":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <InputType
                      type="number"
                      placeholder={field.placeholder || "Enter phone number"}
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={inputStyle}
                    />
                  );
                }
                break;
              case "date":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <InputType
                      type="date"
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={inputStyle}
                    />
                  );
                }
                break;
              case "country":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <SelectBorder
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleInputChange(field.dataName, e.target.value)
                      }
                      required={
                        requiredConditionMet || relatedField?.isRequired
                      }
                      style={inputStyle}
                    >
                      <option value="">Select a country</option>
                      {countries.map((country, index) => (
                        <option key={index} value={country}>
                          {country}
                        </option>
                      ))}
                    </SelectBorder>
                  );
                }
                break;
              case "file":
                if (!hasRendered) {
                  hasRendered = true;
                  return (
                    <InputType
                      type="file"
                      onChange={(event) =>
                        handleFileChange(event, field.dataName)
                      }
                      style={inputStyle}
                    />
                  );
                }
                break;
              default:
                return null;
            }
          })()}
          {errors[field.dataName] && (
            <p style={{ color: "red", fontSize: "12px" }}>
              {errors[field.dataName]}
            </p>
          )}
        </div>
      </div>
    );
  };

  const convertFormDataToSimpleObject = (formData) => {
    const result = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (value && value.value) {
        const keyWithoutTimestamp = key;
        result[keyWithoutTimestamp] = value.value;
      }
    });
    return result;
  };

  const saveForm = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let formIsValid = true;

      Object.keys(formData).forEach((key) => {
        const field = formData[key];
        if (field?.type === "file" && field.file && !field.valid) {
          formIsValid = false;
          toast.error(`Invalid file in ${key}: Check size and type.`);
        }
        if (field?.isRequired && !field.value && field.visible) {
          formIsValid = false;
          toast.error(`Field ${field.label} is required.`);
        }
      });

      if (!formIsValid) {
        console.log("Form contains invalid or missing fields.");
        setLoading(false);
        return;
      }
setLoading(true);

      await uploadFilesToBackend();
setLoading(false);
      const convertedData = convertFormDataToSimpleObject(formData);
      const formPayload = {
        fields: convertedData,
        eventId,
        entryFormId,
        awardcatId: parseInt(selectedAwardId, 10),
        isDraft: false, // 🔥 ADD THIS
        editby: "admin",
          submissionId: submissionId // 🔥 MUST ADD


      };

      const response = await axios.post(
        `${EXCHNAGE_URL}/entryForm_submission`,
        formPayload,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      toast.success("Entry Form Submitted Successfully.");
     
        navigate("/entry-form-listing");
    
    } catch (error) {
      console.error("Error creating form:", error.response.data.message);
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };



useEffect(() => {
  if (!formSchema.length) return;

  const fetchDraft = async () => {
    try {
      const res = await axios.get(
        `${EXCHNAGE_URL}/getentry?eventId=${eventId}&entryFormId=${entryFormId}&awardcatId=${selectedAwardId || 0}`,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const draftData = res.data.data;
const draftAwardId = res.data.awardcatId;
      if (!draftData) return;


if (draftAwardId) {
  setSelectedAwardId(draftAwardId);

  const matchedCategory = categories.find(
    (cat) => cat.awardId === draftAwardId
  );

  if (matchedCategory) {
    setSelectedCategoryName(matchedCategory.category_name);
  }
}

      // 🔥 IMPORTANT: map into existing formData
      setFormData((prev) => {
        const updated = { ...prev };

        Object.keys(draftData).forEach((key) => {
          if (updated[key]) {
            updated[key] = {
              ...updated[key],
              value: draftData[key],
            };
          }
        });

        return updated;
      });

      toast.success("Draft loaded ✅");
    } catch (err) {
      console.log("No draft found");
    }
  };

  fetchDraft();
}, [formSchema, selectedAwardId,categories]);
useEffect(() => {
  if (isEdit && initialData && categories.length > 0) {
    console.log("initialData", initialData);

    // 🔥 find dynamic category key
    const categoryKey = Object.keys(initialData).find((key) =>
      key.toLowerCase().includes("category")
    );

    const categoryValue = categoryKey ? initialData[categoryKey] : "";

    if (categoryValue) {
      const matchedCategory = categories.find(
        (cat) =>
          cat.category_name.trim().toLowerCase() ===
          categoryValue.trim().toLowerCase()
      );

      if (matchedCategory) {
        setSelectedCategoryName(matchedCategory.category_name);
        setSelectedAwardId(matchedCategory.awardId);
      }
    }
  }
}, [isEdit, initialData, categories]);
  return (
    <>
      {isLoading ? (
        <div className="fullscreen-loaderr">
          <div className="loaderr"></div>
        </div>
      ) : (
        <>
         
          <div className="registration_form_main">
            <div className="registration_form">
              <RedMainHeading>Entry Form</RedMainHeading>
            </div>
            <form className="registration_form_div" onSubmit={saveForm}>
              <div className="registration_form_row">
                {isLoading ? (
                  <div className="inline-loaderr">
                    <div className="loaderr"></div>
                  </div>
                ) : (
                  formSchema.map((field) => {
                    const relatedField = formData[field.dataName];
                    const shouldShow = relatedField?.visible;

                    if (!shouldShow) return null;

                    return (
                      <div
                        key={field.dataName}
                        className="registration_form_label"
                      >
                        {renderField(field)}
                      </div>
                    );
                  })
                )}
              </div>
              <div className="registration_form_btn_div">
                <GreyBorderButton type="button" onClick={openCancelModal}>
                  Cancel
                </GreyBorderButton>
              
<RedBackgroundButton type="submit" disabled={isLoading}>
  {isLoading ? "Uploading..." : "Submit"}
</RedBackgroundButton>              </div>
            </form>
          </div>
          <Modal show={isCancelModalOpen} onHide={closeCancelModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Cancellation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to cancel? Your changes will be lost.</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeCancelModal}>
                No, Keep Editing
              </Button>
              <Button variant="danger" onClick={handleCancel}>
                Yes, Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </>
  );
};
